import React from "react";
import { TimeRangePicker as MuiTimeRangePicker } from "@mui/x-date-pickers-pro";
import { time24 } from "../../utils/formatter";
import dayjs from "dayjs";

function timeStrToDayjs(time) {
  return dayjs(`1970-01-01 ${time}`);
}

/**
 * This component hides using dayjs lib.
 */
export default function TimeRangePicker(props) {
  const [internalValue, setInternalValue] = React.useState(
    props.value ?? props.defaultValue ?? ["", ""],
  );
  const ref = React.useRef(null);

  const overrides = { ...props, ref: ref };

  overrides.onChange = function (value, context) {
    const internalValue = value.map((value) => time24(value?.$d) ?? "");
    setInternalValue(internalValue);
    props?.onChange?.(internalValue, context);
  };

  if (props.defaultValue != null) {
    overrides.defaultValue = props.defaultValue.map((v) =>
      v.length === 0 ? null : timeStrToDayjs(v),
    );
  }

  overrides.onError = function (error) {
    const valid = error.every((e) => e == null);
    const inputEl = ref.current?.querySelector("input");

    const message = valid ? "" : "První čas musí být menší než druhý.";
    inputEl?.setCustomValidity(message);
  };

  return (
    <>
      <MuiTimeRangePicker {...overrides} />
      <input type="hidden" name={props.nameFrom} value={internalValue[0]} />
      <input type="hidden" name={props.nameTo} value={internalValue[1]} />
    </>
  );
}
